import { useState } from "react";
import cylindaLogo from "../assets/images/loading/cylinda-logo.png";
import minus from "../assets/images/accordionMinus.svg";
import plus from "../assets/images/accordionPlus.svg";
import { useTranslation } from "react-i18next";
import dompurify from "dompurify";
import { PlusIcon, MinusIcon } from "@heroicons/react/20/solid";

function Support() {
  const [selected, setSelected] = useState(null);
  const { t } = useTranslation();
  const afterSignupUrl = process.env.REACT_APP_AFTER_SIGNUP_URL;
  const storeUrl = process.env.REACT_APP_STORE_URL;
  const supportUrl = storeUrl
    ? `${storeUrl}support-c-2299`
    : "https://www.cylinda.se/support-c-2299";


const data = [
    {
      question: "1. " + t("support.question1"),
      answer: t("support.answer1", {
        afterSignupUrl,
      }),
    },
    {
      question: "2. " + t("support.question2"),
      answer: t("support.answer2"),
    },
    {
      question: "3. " + t("support.question3"),
      answer: t("support.answer3"),
    },
    {
      question: "4. " + t("support.question4"),
      answer: t("support.answer4"),
    },
    {
      question: "5. " + t("support.question5"),
      answer: t("support.answer5"),
    },
    {
      question: "6. " + t("support.question6"),
      answer: t("support.answer6"),
    },
    {
      question: "7. " + t("support.question7"),
      answer: t("support.answer7"),
    },
    {
      question: "8. " + t("support.question8"),
      answer: t("support.answer8"),
    },
    {
      question: "9. " + t("support.question9"),
      answer: t("support.answer9"),
    },
    {
      question: "10. " + t("support.question10"),
      answer: t("support.answer10"),
    },
  ];

  const toggle = (i) => {
    if (selected === i) {
      return setSelected(null);
    }
    setSelected(i);
  };
  const toggleLeave = (i) => {
    if (selected === i) {
      return setSelected(null);
    }
    setSelected(null);
  };

  const markup = (text) => {
    const element = dompurify.sanitize(text);
    return { __html: element };
  };

  return (
    <>
      <div className="content-page">
          <div className="support-options">
          <div className="option">
            <a
              className="cylinda-support-card"
              style={{ textDecoration: "none" }}
              href={supportUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="cylinda-support-logo"
                src={cylindaLogo}
                alt={t("support.cylindaSupportAlt")}
              />
              <div className="support-option-title">
                {t("support.cylindaSupportLabel")}
              </div>
            </a>
          </div>
        </div>
        <div className="accordion-wrapper">
          <div className="accordion">
            {data.map((item, index) => (
              <div key={index} className="accordion-item">
                <div className="accordion-title" onClick={() => toggle(index)}>
                  <div className="accordion-header">
                    <h2
                      className={selected === index ? "selected-accordion" : ""}
                    >
                      {item.question}
                    </h2>
                    <div>
                      {selected === index ? (
                        <>
                          <MinusIcon style={{width:24+'px', height: 24+'px'}} />
                        </>
                      ) : (
                        <>
                          <PlusIcon style={{width:24+'px', height: 24+'px'}} />
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    className={
                      selected === index
                        ? "accordion-content show"
                        : "accordion-content"
                    }
                    onClick={() => toggleLeave(index)}
                  >
                    <div
                      dangerouslySetInnerHTML={markup(item.answer)}
                      className="accordion-section"
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Support;
